// Curated background swatches and font catalogs for the Image Studio "Excerpt Image" tab.
export const LIGHT_SWATCHES: { name: string; hex: string }[] = [
  { name: "Soft white", hex: "#FBFAF7" },
  { name: "Cream", hex: "#F5EFE0" },
  { name: "Blush", hex: "#F8E1E1" },
  { name: "Peach", hex: "#FBE4D0" },
  { name: "Butter", hex: "#FDF1C5" },
  { name: "Mint", hex: "#DDF2E4" },
  { name: "Sage", hex: "#D5E3D2" },
  { name: "Sky", hex: "#DEEBF6" },
  { name: "Periwinkle", hex: "#DDE0F4" },
  { name: "Lilac", hex: "#E8DDF2" },
  { name: "Rose", hex: "#F2D7DE" },
  { name: "Sand", hex: "#EDE3CF" },
];

export const DARK_SWATCHES: { name: string; hex: string }[] = [
  { name: "Pure black", hex: "#000000" },
  { name: "Deep charcoal", hex: "#111111" },
  { name: "Ink", hex: "#171821" },
  { name: "Midnight", hex: "#0F1B2D" },
  { name: "Navy", hex: "#15243C" },
  { name: "Forest", hex: "#16291E" },
  { name: "Plum", hex: "#241423" },
  { name: "Espresso", hex: "#2A1B12" },
  { name: "Slate", hex: "#1F2933" },
  { name: "Oxblood", hex: "#3A1116" },
  { name: "Teal-black", hex: "#0E2126" },
  { name: "Graphite", hex: "#252525" },
];

export const SERIF_FONTS = ["Fraunces", "Gilda Display", "Alice", "Literata", "Caudex", "Inknut Antiqua", "Vollkorn"];
export const SANS_FONTS = ["Open Sans", "Inter", "Roboto", "Poppins", "Rubik", "Outfit", "Barlow"];

export const stripUrl = (u: string) =>
  u.replace(/^https?:\/\//i, "").replace(/^www\./i, "").replace(/\/+$/, "");

const loadedFonts = new Set<string>();
export const ensureFont = (family: string) => {
  if (loadedFonts.has(family)) return;
  loadedFonts.add(family);
  const link = document.createElement("link");
  const fam = family.replace(/ /g, "+");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fam}:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&display=swap&subset=latin,latin-ext,greek,hebrew`;
  document.head.appendChild(link);
};
